import { Sender } from 'xstate';
import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { UserInterpreter } from '../user.xstate';
import { globalAppService } from '../app.xstate';
import { GLOBAL_APP_SUB_MACHINE_IDS } from '../app.xstate-utils';
import { checkForErrors, extractUserProjects, UserProject } from '../../utils';

let hasUpdateUserInfoSubRun = false;

export const getUserData =
  (ctx: ProStudioContext, _event: ProStudioEvents) =>
  async (sendEvent: Sender<ProStudioEvents>) => {
    const userService = globalAppService.children.get(
      GLOBAL_APP_SUB_MACHINE_IDS.user
    ) as UserInterpreter;

    const userServiceSubscription = userService?.subscribe(async (state) => {
      const userContext = state?.context;

      const userId = userContext?.user?.id;

      if (!userId) return;

      if (hasUpdateUserInfoSubRun === false) {
        hasUpdateUserInfoSubRun = true;
        const defaultOrgId = userContext?.user?.defaultAccount?.defaultOrgId;
        const email = userContext?.user?.email;
        const status = userContext?.user?.status;
        const firstName = userContext?.user?.firstName;
        const lastName = userContext?.user?.lastName;
        // const projectIdsAssignedThroughTeams = compact(
        //   userContext?.user?.assignedTeams
        //     ?.map(({ assignedProjects }) =>
        //       assignedProjects?.map((assignedProject) => assignedProject.id)
        //     )
        //     .flat()
        // );

        // const accountId = ctx.accountId || defaultOrgId;

        // if (!accountId || !email) return;

        const userProjectsResponse = await urqlGql.getUserProjects({
          userId,
        });

        checkForErrors(userProjectsResponse);

        const userProjects = extractUserProjects(
          userProjectsResponse.data?.tenancy_users[0]
        );

        // const userDataResponse = await urqlGql
        //   .getUserSettings({
        //     accountId,
        //     userId,
        //     email,
        //   })
        //   .toPromise();

        // checkForErrors(userDataResponse);

        // const { data } = userDataResponse;

        const nextUserInfoState: ProStudioContext['userInfo'] & {
          userProjects: UserProject[];
        } = {
          ...ctx.userInfo,
          id: userId,
          defaultOrgId,
          email,
          userProjects,
          status,
          firstName,
          lastName,
          // status: data?.admin_?.currentUser?.status || status,
          // productRoles: data?.admin_?.userProductRoles || {},
          // recommendedAuthMethod:
          //   data?.admin_?.getLoginInfo?.recommendedAuthMethod,
          // registeredAuthMethods:
          //   data?.admin_?.getLoginInfo?.registeredAuthMethods || [],
          // canManageAccess: Boolean(
          //   data?.admin_?.organizationMetadata?.canManageAccess
          // ),
          // defaultLanguage:
          //   data?.admin_?.currentUser?.settings?.defaultLanguage?.split(
          //     '-'
          //   )?.[0],
        };

        sendEvent({
          type: 'updateUserInfo',
          data: nextUserInfoState,
        });
      }
    });

    if (hasUpdateUserInfoSubRun) {
      userServiceSubscription.unsubscribe();
    }
  };
